import { getEntityFromString } from 'utils/getEntityFromString';
import { getLiteral } from 'utils/getLiteral';
import { ensureRoute } from 'utils/routes';
import { COPILOT_ACTION_TYPES } from '../constants';

export const showEntityDetailAction = {
    key: COPILOT_ACTION_TYPES.SHOW_ENTITY_DETAIL,
    definition: {
        getCta: () => getLiteral('action_copilot_go_to_entity'),
        action: (params) => {
            const { entity, entityId, queryString } = params;

            if (!entity || !entityId) {
                console.warn('Missing required parameters: entity and entityId are required');
                return false;
            }

            const entityObject = getEntityFromString(entity);
            if (!entityObject) {
                console.warn(`Unknown entity type: ${entity}`);
                return false;
            } else {
                ensureRoute(`${entityObject.route}/${entityId}`, queryString);
            }
        },
    },
};
